import { __read } from "tslib";
import { connect, filter, map, pipe, statefulStream, system, tup, } from '@virtuoso.dev/urx';
import { listStateSystem } from './listStateSystem';
export var topItemCountSystem = system(function (_a) {
    var _b = __read(_a, 1), topItemsIndexes = _b[0].topItemsIndexes;
    var topItemCount = statefulStream(0);
    connect(pipe(topItemCount, filter(function (length) { return length > 0; }), map(function (length) { return Array.from({ length: length }).map(function (_, index) { return index; }); })), topItemsIndexes);
    return { topItemCount: topItemCount };
}, tup(listStateSystem));
